export default __webpack_public_path__ + "static/media/login.3f127d3a.jpg";